import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select, Switch, Typography, Tag, message  } from 'antd';
import Ingredient from "../../../model/menudesign/Ingredient";
import Colors from "../../../styles/Colors";
import {BiCheck, BiX, BiPlus, BiBorderRadius } from "react-icons/bi";
import {PostIngredient} from "../../../dao/menudesign/PostIngredient"
import { GetAlergens } from '../../../dao/inscripcions/GetAlergens';
import { GetVariants } from '../../../dao/menudesign/GetVariants';
import { GetProveidors} from '../../../dao/menudesign/GetProveidors'
import MesuraField from '../components/MesuraField'
import Variacio from '../../../model/menudesign/Variacio';
import VariacioIngredient from '../../../model/menudesign/VariacioIngredient';
import ProveidorModal from "../../menudesign/components/ProveidorModal";
import VariacioModal from "../../menudesign/components/VariacioModal";
import AlergenModal from "../../root/component/AlergensModal";
import Proveidor from '../../../model/menudesign/Proveidor';
import toast, {Toaster} from "react-hot-toast";
import {BsEye, BsPlusCircle, BsReceiptCutoff} from "react-icons/bs";
import Alergen from '../../../model/inscripcions/Alergen';
import {AuthContext} from "../../../config/AuthContext";

interface IngredientModalProps {
    ingredient: Ingredient;
    visible: boolean;
    editar?: boolean;
    onClose: (value: boolean) => void;
    page: string;
}
const { Option } = Select;
const { Text } = Typography;

const IngredientModal: React.FC<IngredientModalProps> = ({ingredient, visible, onClose, editar, page}) => {
    const [form] = Form.useForm();
    const [coleccio, setDades] = useState<any[]>([]);
    const [coleccioVariants, setDadesVariants] = useState<Variacio[]>([]);
    const [coleccioProveidors, setDadesProveidors] = useState<any[]>([]);
    const [showAlergenSelect, setShowAlergenSelect] = useState(false);
    const [alergensList, setAlergensList] = useState([]);
    const [showAlergens, setShowAlergens] = useState(false);
    const [nouProveidor, setNouProveidor] = useState(false);
    const [nouVariant, setNouVariant] = useState(false);
    const [nouAlergen, setNouAlergen] = useState(false);
    const {isLoggedIn, userId, user} = useContext(AuthContext);
  


    const tipusOptions: Record<string, string> = {
        pasta: "pasta",
        arròs: "arròs",
        gra: "gra",
        verdura: "verdura",
        vegetal: "vegetal",
        cereal: "cereal",
        hortalissa: "hortalissa",
        tubercle: "tubercle",
        "carn vermella": "carn vermella",
        "carn blanca": "carn blanca",
        peix: "peix",
        ou: "ou",
        fruita: "fruita",
        lactic: "lactic",
        condiment: "condiment",
        "greix vegetal": "greix vegetal",
        especia: "especia",
        altres: "altres",
    };


    
    useEffect(() => {
        if (visible) {
            checkAlergens(); 
            loadVariants();
        }
    }, [visible]);

    useEffect(() => {
        if (visible && ingredient?.id) {
            const values = {
                ...ingredient,
                cuina: parseInt(ingredient.cuina) === 1,
                proposta: parseInt(ingredient.proposta) === 1,
                alergia: false, 
            };

            if (ingredient.alergen_ingredient && ingredient.alergen_ingredient.length > 0) {
                
                const alergensObj: Record<string, number> = {};
                ingredient.alergen_ingredient.forEach((al: any) => {
                    alergensObj[al.id_alergen] = al.tipus;
                });

                values.alergia = true;
                
                form.setFieldsValue({
                    ...values,
                    alergen_ingredient: alergensObj,
                });
                setShowAlergens(true);
            } else {
                form.setFieldsValue(values);
                setShowAlergens(false);
            }
        }
    }, [visible, editar, ingredient]);

    
    const handleCloseNouVariant = async () => {
        setNouVariant(false);
        await loadVariants(); // vuelve a cargar variants por si se añadió una nueva
    };
    async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouProveidor(false);
        setNouAlergen(false);
        checkAlergens();
    }

    const handleOpenNouProveidor = () => {
        setNouProveidor(true);
    };

    const handleOpenNouVariant = () => {
        setNouVariant(true);
    };
    const handleOpenNouAlergen = () => {
        setNouAlergen(true);
    };


    async function checkAlergens() {
        try {
            const dades = await GetAlergens(page);
            const dadesProveidors = await GetProveidors(page);
            setDades(dades || []);
            setDadesProveidors(dadesProveidors || []);
        } catch (error) {
            console.error("Error cargando alérgenos o proveedores:", error);
            setDades([]);
            setDadesProveidors([]);
        }
    }

    const loadVariants = async () => {
        try {
            const dadesVariants = await GetVariants(page);
            setDadesVariants(dadesVariants || []);

            if ( ingredient?.variacio_ingredient?.length > 0) {
                const variantIds = ingredient.variacio_ingredient.map((v: any) =>
                    typeof v === 'object' ? v.id_variacio : v
                );

                form.setFieldsValue({
                    variacio_ingredient: variantIds
                });
            }
        } catch (error) {
            console.error("Error cargando variants:", error);
            setDadesVariants([]);
        }
    };
    async function handleSubmit() {
    const formData = form.getFieldsValue();

    // Convertir booleans a 1/0
    formData.cuina = formData.cuina ? 1 : 0;
    formData.proposta = formData.proposta ? 1 : 0;
    formData.alergia = formData.alergia ? 1 : 0;

    // Convertir alergens
    if (formData.alergen_ingredient) {
        const alergenArray = Object.entries(formData.alergen_ingredient)
            .map(([id_alergen, tipus]) => ({
                id_alergen: parseInt(id_alergen),
                tipus: tipus
            }));
        formData.alergen_ingredient = JSON.stringify(alergenArray);
    }

    // Convertir variants
    if (formData.variacio_ingredient && Array.isArray(formData.variacio_ingredient)) {
        const variantsArray = formData.variacio_ingredient.map((id: number) => ({
            id_variacio: id
        }));
        formData.variacio_ingredient = JSON.stringify(variantsArray);
    }

    console.log("Form Data:", formData);
    await PostIngredient(page, formData, userId);
    onClose(true);
}


const handleAlergenSwitchChange = (checked: boolean) => {
    setShowAlergens(checked);
    if (!checked) {
        form.setFieldsValue({ alergens: {} }); // limpia al desactivar
    }
};
    const handleCancel = () => {
        onClose(false);
    };

    return (
        <Modal
            title="Crear/Editar Ingredient"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={1000}
        >
            <Toaster/>
            <Form form={form} initialValues={ingredient} onFinish={handleSubmit}  disabled={!editar}>
                <Row gutter={[8, 8]} >
                    <Col span={12} style={{padding:'15px'}}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Tipus" name="tipus"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                placeholder="Selecciona tipus d'ingredient"
                                options={Object.entries(tipusOptions).map(([value, label]) => ({
                                    value,
                                    label,
                                }))}
                            />
                        </Form.Item>
                        <Row gutter={[8, 8]}>
                            <Col span={12}>
                                <MesuraField form={form} editar={editar} />
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Preu" name="preu"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Input type="number"/>
                                </Form.Item>
                            </Col>
                        </Row>
                     
                        
                        <Form.Item label="Stock Mínim" name="minim_stock"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Arrodoniment Comanda" name="arrodoniment_comanda"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Arrodoniment Repartir" name="arrodoniment_repartir"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                         <Row gutter={[8, 8]}>
                            <Col span={12}>
                                <Form.Item label="Precisa cuina:" name="cuina" valuePropName="checked">
                                    <Switch checkedChildren="SI" unCheckedChildren="NO" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Proposta" name="proposta" valuePropName="checked">
                                    <Switch checkedChildren="SI" unCheckedChildren="NO"/>
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>
                    <Col span={12} style={{padding:'15px'}}>
                        
                        <Form.Item label="Té al·lèrgens" name="alergia" valuePropName="checked" style={{marginBottom:-10}}>
                            <Switch onChange={handleAlergenSwitchChange} disabled={!editar} checkedChildren="SI" unCheckedChildren="NO"/>
                        </Form.Item>
                        <hr/>
                        {showAlergens && (
                            <>
                            <Form.Item
                            style={{ marginBottom: 0 }}
                            >
                            {coleccio.map((alergen) => (
                                <Row gutter={8} key={alergen.id} align="middle" style={{ marginBottom: 3 }}>
                                <Col span={2}>
                                </Col>
                                <Col span={10}>
                                    <Text>{alergen.nom}</Text>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name={['alergen_ingredient', alergen.id]}
                                        style={{ marginBottom: 0 }}
                                        initialValue={0} 
                                    >
                                    <Select
                                        placeholder="Selecciona tipus"
                                        disabled={!editar}
                                        
                                    >
                                        <Option value= {2}>
                                            <span>Conte</span></Option>
                                        <Option value= {1} >
                                            <span >Conte traces</span></Option>
                                        <Option value={0}>
                                            <span style={{ color: "#9e1a00" }}>No conte</span></Option>

                                    </Select>
                                    </Form.Item>
                                </Col>
                                </Row>
                            ))}
                            </Form.Item>
                            <div style={{textAlign:'center', marginTop:'10px'}}>
                                <Button title={"Afegir nou al·lèrgen"} onClick={() =>
                                    handleOpenNouAlergen()}><BsPlusCircle color={Colors.colors.color2} style={{marginInlineEnd:'5px'}}/>Afegir nou Al·lèrgen</Button>
                            </div>
                                
                            <hr/>
                            </>
                        )}
                     
                        <Row>
                          <h6>Variants (Menú)<Button title={"Afegir nova variant"} style={{border:'0px'}} onClick={() =>
                                handleOpenNouVariant()}><BsPlusCircle color={Colors.colors.color2 }/></Button>  </h6>
                        </Row>
                        

                        <Form.Item name="variacio_ingredient">
                            <Select
                                mode="multiple"
                                placeholder="Selecciona variants"
                                disabled={!editar}
                            >
                                {coleccioVariants.map((variant) => (
                                    <Option key={variant.id} value={variant.id}>
                                        {variant.nom}
                                    </Option>
                                ))}
                        
                            </Select>
                        </Form.Item>

                        
                        <h6>Proveïdors <Button title={"Afegir nou proveïdor"} style={{border:'0px'}} onClick={() =>
                                handleOpenNouProveidor()}><BsPlusCircle color={Colors.colors.color2 }/></Button></h6>
                        <hr/>
                        <Form.Item
                        label="Proveïdor 1"
                        name="idProveidor1"
                        rules={[{ required: true, message: 'Aquest camp és obligatori' }]}
                        >
                        <Select
                            placeholder="Selecciona proveïdor"
                            disabled={!editar}
                            allowClear
                        >
                            {coleccioProveidors.map((proveidor) => (
                            <Option key={proveidor.id} value={proveidor.id}>
                                {proveidor.nom}
                            </Option>
                            ))}
                        
                        </Select>
                        </Form.Item>

                        <Form.Item label="Proveïdor 2" name="idProveidor2" initialValue={0}>
                            <Select
                                placeholder="Selecciona proveïdor"
                                disabled={!editar}
                                options={[
                                { value: 0, label: 'Sense proveïdor' },
                                ...coleccioProveidors.map((p) => ({
                                    value: p.id,
                                    label: p.nom,
                                }))
                                ]}
                            />
                            </Form.Item>

                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>

            {nouProveidor && (
                <ProveidorModal element={new Proveidor()} onClose={handleCloseModal} visible={nouProveidor} editar={true}/>
            )}
            {nouVariant && (
                <VariacioModal element={new Variacio()} onClose={handleCloseNouVariant} visible={nouVariant} editar={true} page={page}/>
            )}
            {nouAlergen && (
                <AlergenModal element={new Alergen()} onClose={handleCloseModal} visible={nouAlergen} editar={true} page={page}/>
            )}
        </Modal>
    );
};

export default IngredientModal;
